module.exports = __webpack_public_path__ + "static/04-5ef7993aeda2d13fe32e3da58dde5038.jpg";